"use strict";
const angular = require("angular");

/*@ngInject*/
export function productService($resource) {
  // AngularJS will instantiate a singleton by calling "new" on this function
  "ngInject";

  return $resource(
    "/api/demands/:id/:controller",
    {
      id: "@id",
    },
    {
      getModels: { method: "GET", params: { id: "products" }, isArray: true },
      getFull: { method: "GET", params: { controller: "full" } },
      getDefaultInputs: {
        method: "GET",
        params: { controller: "default-inputs" },
        isArray: true,
      },
      getRestricted: { method: "GET", params: { controller: "restricted" } },
      get: { method: "GET" },
      getFileInput: { method: "GET", params: { id: "files" } },
      save: { method: "POST" },
      change: { method: "PUT" },
      manageClient: { method: "PUT", params: { controller: "manage-client" } },
      changeStatus: { method: "PUT", params: { controller: "status" } },
      delete: { method: "DELETE" },
    }
  );
}

export default angular
  .module("dalApp.product.api", [])
  .service("ProductAPI", productService).name;



// WEBPACK FOOTER //
// ./client/app/permission/product/product.service.js